export default "__VITE_ASSET__CvtTs0wq__"